import React from 'react';
import {
  Button,
  ButtonGroup,
  ButtonGroupProps,
  ButtonProps,
} from '../../components';
import { cn } from '../../utils';

export interface ButtonGroupInputOption {
  value: string;
  text: string;
}

export interface ButtonGroupInputProps extends ButtonGroupProps {
  options: ButtonGroupInputOption[];
  value?: string;
  onValueChange?: (value: string) => void;
  buttonProps?: ButtonProps & { activeClassName?: string };
}

export const ButtonGroupInput = ({
  options,
  onValueChange,
  value: selectedValue,
  buttonProps: { activeClassName, ...buttonProps } = {},
  ...props
}: ButtonGroupInputProps) => (
  <ButtonGroup {...props}>
    {options.map(({ value, text }) => (
      <Button
        type="button"
        key={value}
        {...buttonProps}
        onClick={() => onValueChange?.(value)}
        value={value}
        className={cn(
          'border-secondary text-secondary w-full border-[1.5px]',
          buttonProps?.className,
          {
            [activeClassName || 'bg-secondary text-primary-foreground']:
              selectedValue === value,
          }
        )}
      >
        {text}
      </Button>
    ))}
  </ButtonGroup>
);
